import { createContext, Dispatch, SetStateAction } from 'react';

export const currentSameIssuerSAccIdContext = createContext<[string, Dispatch<SetStateAction<string>>]>(['', () => {
  throw new Error('not in currentSameIssuerSAccIdContext');
}]);
